import { connect } from "react-redux";
import * as Auth from "redux-store/auth/selectors";

import { PrivateRoute } from "./private-route";

function mapStateToProps(state) {
  const auth = Auth.authSelector(state);
  const isAuthenticated = Auth.isAuthenticated(auth);

  return {
    isAuthenticated,
  };
}

const ConnectedPrivateRoute = connect(mapStateToProps)(PrivateRoute);

export { ConnectedPrivateRoute };
